import { PageRequest } from '@elotech/components';
import axios, { AxiosPromise } from 'axios';
import { UsuarioEntidade } from 'common/type';

const BASE_URL = '/painel-api/api/usuario-entidade';
export const vincularEntidade = (
  idUsuario: string,
  idEntidade: string
): AxiosPromise<UsuarioEntidade> =>
  axios.post(`${BASE_URL}/${idUsuario}/vincular/${idEntidade}`);

export const removeVinculoEntidade = (
  idUsuario: string,
  idEntidade: string
): AxiosPromise<UsuarioEntidade> =>
  axios.delete(`${BASE_URL}/${idUsuario}/desvincular/${idEntidade}`);

export const togglePadrao = (
  idUsuario: string,
  idEntidade: string
): AxiosPromise<UsuarioEntidade> =>
  axios.put(`${BASE_URL}/${idUsuario}/toggle-padrao/${idEntidade}`);

export const findAllEntidadesDisponiveisToUsuario = (
  idUsuario: string,
  search?: string
): AxiosPromise<UsuarioEntidade[]> =>
  axios.get(`${BASE_URL}/${idUsuario}/disponiveis`, {
    params: {
      search
    }
  });
export const findAllEntidadesByUsuario = (
  idUsuario: string,
  search?: string,
  pagination?: PageRequest
): AxiosPromise<UsuarioEntidade[]> =>
  axios.get(`${BASE_URL}/${idUsuario}/vinculadas`, {
    params: {
      search,
      ...pagination
    }
  });
